import { Component, Input, OnInit } from '@angular/core';
import { GarantiasIdoneasCobrosPerfilesRiesgos } from '../../../_models/garantias-idoneas-cobros-perfiles-riesgos';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PerfilRiesgoService } from '../../../_services/perfil-riesgo.service';
import { PlanCargoService } from '../../../_services/plan-cargo.service';
import { GarantiaIdoneaCobrosPerfilesRiesgosService } from '../../../_services/garantia-idonea-cobros-perfiles-riesgos.service';
import { GarantiasIdoneas } from '../../../_models/garantias-idoneas';
import { NavService } from '../../../_services/_nav.service';
import { forkJoin } from 'rxjs';
import { PerfilRiesgo } from '../../../_models/perfil-riesgo';
import { PlanCargo } from '../../../_models/plan-cargo';
import { ListaService } from '../../../_services/lista.service';
import { ListaItem } from '../../../_models/lista-item';

@Component({
  selector: 'app-cobros-perfiles-riesgos',
  templateUrl: './cobros-perfiles-riesgos.component.html',
  styleUrls: ['./cobros-perfiles-riesgos.component.css']
})
export class CobrosPerfilesRiesgosComponent implements OnInit {

  @Input() garantiaIdonea: GarantiasIdoneas;
  listado: GarantiasIdoneasCobrosPerfilesRiesgos[] = [];
  listadoTodos: GarantiasIdoneasCobrosPerfilesRiesgos[] = [];
  columnas: any[] = [];
  formulario: FormGroup;
  submitted = false;
  cargando = true;
  regSeleccionado: GarantiasIdoneasCobrosPerfilesRiesgos;
  lisPerfilesTodos: PerfilRiesgo[] = [];
  lisPlanesCargosTodos: PlanCargo[] = [];
  lisPerfiles: SelectItem[] = [];
  lisPlanesCargo: SelectItem[] = [];
  lisPlanCargoComodin: SelectItem[] = [];
  validarMaximo: boolean = true;

  constructor(private navService: NavService,
    private fb: FormBuilder,
    private garIdoneaCobroPerfilRiesgoService: GarantiaIdoneaCobrosPerfilesRiesgosService,
    private plaCargoService: PlanCargoService,
    private perRiesgoService: PerfilRiesgoService,
    private conService: ConfirmationService,
    private lisServicio: ListaService,) {
  }

  async ngOnInit() {
    this.columnas = [
      { field: 'codigoPerfilRiesgo', header: this.navService.buscarMensaje('GARANTIASIDONEAS.LBL_PERFILRIESGO'), sort: true },
      { field: 'montoInicial', header: this.navService.buscarMensaje('GARANTIASIDONEAS.LBL_MONTOINICIAL'), sort: true },
      { field: 'montoFinal', header: this.navService.buscarMensaje('GARANTIASIDONEAS.LBL_MONTOFINAL'), sort: true },
      { field: 'porcentajeCobro', header: this.navService.buscarMensaje('GARANTIASIDONEAS.LBL_COBROPORCEN'), sort: true },
      { field: 'codigoPlanCargo', header: this.navService.buscarMensaje('GARANTIASIDONEAS.LBL_COMODIN'), sort: true },
      { field: 'det', header: this.navService.buscarMensaje('LBL_ACCIONES'), sort: false }
    ];
    const [
      listado,
      perfiles,
      // planCargos,
      lisPlanCargoComodin
    ] = await forkJoin(
      this.garIdoneaCobroPerfilRiesgoService.listadoPorIdGarantiaIdonea(this.garantiaIdonea.idGarantiaIdonea),
      this.perRiesgoService.listadoHabilitados(),
      // this.plaCargoService.listadoHabilitados(),
      this.lisServicio.getMasterDetails('ListasComodinPlanesCargo')
    ).toPromise();

    this.listadoTodos = listado;
    this.cargarFormulario();
    this.cargarListado();
    this.lisPerfilesTodos = perfiles.sort((a, b) => a.codigo > b.codigo ? 1 : -1);
    // this.lisPlanesCargosTodos = planCargos.sort((a, b) => a.codigo > b.codigo ? 1 : -1);
    // this.lisPlanesCargo = this.lisPlanesCargosTodos.map(s => ({ value: s.idPlanCargo, label: `${s.codigo}-${s.nombre}` }));
    lisPlanCargoComodin.map((s: ListaItem) => {
      this.lisPlanCargoComodin.push({ label: s.nombre, value: s.idLista });
    });
    this.cargarPerfiles();
    this.cargando = false;
  }

  cargarListado() {
    this.listado = this.listadoTodos.filter(x => x.indicadorHabilitado);
    this.ordenar();
  }

  cargarPerfiles() {
    this.lisPerfiles = [];
    this.lisPerfilesTodos.forEach(e => {
      this.lisPerfiles.push({ value: e.idPerfilRiesgo, label: `${e.codigo}-${e.nombreRiesgo}` });
      // Filtro para limpiar perfiles ya configurados deshabilitado ⬇️
      // if ( !this.listado.find( x => x.idPerfilRiesgo === e.idPerfilRiesgo ) ) {
      //   this.lisPerfiles.push( { value: e.idPerfilRiesgo, label: `${e.codigo}-${e.nombreRiesgo}` } );
      // }
    });
  }

  ordenar() {
    this.listado = this.listado.sort(function (a, b) {
      if (a.codigoPerfilRiesgo > b.codigoPerfilRiesgo) {
        return 1;
      }
      if (a.codigoPerfilRiesgo < b.codigoPerfilRiesgo) {
        return -1;
      }
      return 0;
    });
  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      idGarantiaIdoneaCobroPerfilRiesgo: [this.regSeleccionado ? this.regSeleccionado.idGarantiaIdoneaCobroPerfilRiesgo : null, this.regSeleccionado ? [Validators.required] : []],
      idGarantiaIdonea: [this.regSeleccionado ? this.regSeleccionado.idGarantiaIdonea : this.garantiaIdonea.idGarantiaIdonea, [Validators.required]],
      idPerfilRiesgo: [this.regSeleccionado ? this.regSeleccionado.idPerfilRiesgo : null, [Validators.required]],
      idComodinPlanCargo: [this.regSeleccionado ? this.regSeleccionado.idComodinPlanCargo : null, [Validators.required]],
      montoInicial: [this.regSeleccionado ? this.regSeleccionado.montoInicial : null, [Validators.required]],
      montoFinal: [this.regSeleccionado ? this.regSeleccionado.montoFinal : null, [Validators.required]],
      porcentajeCobro: [this.regSeleccionado ? this.regSeleccionado.porcentajeCobro : null, [Validators.required]],
      indicadorHabilitado: [this.regSeleccionado ? this.regSeleccionado.indicadorHabilitado : true, [Validators.required]]
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.validarMaximo && !this.formulario.valid) {
      return;
    }

    this.cargando = true;
    const registro = this.formulario.value;

    if (registro.idGarantiaIdoneaCobroPerfilRiesgo !== '' && registro.idGarantiaIdoneaCobroPerfilRiesgo !== null && registro.idGarantiaIdoneaCobroPerfilRiesgo !== undefined) {
      this.garIdoneaCobroPerfilRiesgoService.verificarRango(registro).subscribe(response => {
        if (response.estado) {
          this.garIdoneaCobroPerfilRiesgoService.actualizar(registro).subscribe(rta => {
            this.actualizarTabla()
            this.reiniciarForm()
            this.cargando = false;
            this.navService.setMesage(1);
          }, error => {
            this.cargando = false;
            this.navService.setMesage(3);
          });
        } else {
          this.conService.confirm({
            header: this.navService.buscarMensaje("LBL_CONFIRMACION"),
            message: this.navService.buscarMensaje("GARANTIASIDONEAS.MSG_CONFIRMACION"),
            icon: 'fa fa-question-circle',
            key: `garantia-idonea-cobros-perfiles`,
            accept: () => {
              this.garIdoneaCobroPerfilRiesgoService.actualizarBulk(response.listado).subscribe(rta => {
                this.actualizarTabla()
                this.reiniciarForm()
                this.cargando = false;
                this.navService.setMesage(1);
              }, error => {
                this.cargando = false;
                this.navService.setMesage(3);
              });
            },
            reject: () => {
              this.cargando = false;
            },
          });
        }
      }, error => {
        this.navService.setMesage(3);
      });
    } else {
      this.garIdoneaCobroPerfilRiesgoService.verificarRango(registro).subscribe(response => {
        if (!response.estado) {
          this.conService.confirm({
            header: this.navService.buscarMensaje("LBL_CONFIRMACION"),
            message: this.navService.buscarMensaje("GARANTIASIDONEAS.MSG_CONFIRMACION"),
            icon: 'fa fa-question-circle',
            key: `garantia-idonea-cobros-perfiles`,
            accept: () => {
              this.garIdoneaCobroPerfilRiesgoService.actualizarBulk(response.listado).subscribe(rta => {
                this.actualizarTabla()
                this.reiniciarForm()
                this.cargando = false;
                this.navService.setMesage(1);
              }, error => {
                this.cargando = false;
                this.navService.setMesage(3);
              });
            },
            reject: () => {
              this.cargando = false;
            },
          });
        } else {
          this.garIdoneaCobroPerfilRiesgoService.crear(registro).subscribe(rta => {
            this.actualizarTabla()
            this.reiniciarForm()
            this.cargando = false;
            this.navService.setMesage(1);
          }, error => {
            this.cargando = false;
            this.navService.setMesage(3);
          });
        }
      }, error => {
        this.navService.setMesage(3);
      });
    }

    // this.cargando = true;
    // const registro = this.formulario.value;
    // this.actualizarCamposRegistro(registro);
    // if ( registro.idGarantiaIdoneaCobroPerfilRiesgo ) {
    //   this.actualizarRegistro( registro );
    // } else {
    //   const existe = this.listadoTodos.find( x => x.idPerfilRiesgo === registro.idPerfilRiesgo );
    //   if ( existe ) {
    //     registro.idGarantiaIdoneaCobroPerfilRiesgo = existe.idGarantiaIdoneaCobroPerfilRiesgo;
    //     this.actualizarRegistro( registro );
    //   } else {
    //     this.garIdoneaCobroPerfilRiesgoService.crear( registro ).subscribe( r => {
    //       registro.idGarantiaIdoneaCobroPerfilRiesgo = r.idGarantiaIdoneaCobroPerfilRiesgo;
    //       this.listadoTodos.push( registro );
    //       this.cargarListado();
    //       this.finalizarGuardado( registro, 1 );
    //     } );
    //   }
    // }
  }

  actualizarRegistro(registro: GarantiasIdoneasCobrosPerfilesRiesgos) {
    this.garIdoneaCobroPerfilRiesgoService.actualizar(registro).subscribe(r => {
      const itemIndex = this.listadoTodos.findIndex(x => x.idGarantiaIdoneaCobroPerfilRiesgo === registro.idGarantiaIdoneaCobroPerfilRiesgo);
      if (itemIndex >= 0) {
        this.listadoTodos[itemIndex] = registro;
      }
      this.cargarListado();
      this.finalizarGuardado(registro, 2);
    });
  }

  actualizarCamposRegistro(registro: GarantiasIdoneasCobrosPerfilesRiesgos) {
    const itemPlanCargo = this.lisPlanesCargosTodos.find(x => x.idPlanCargo === registro.idComodinPlanCargo);
    if (itemPlanCargo) {
      registro.planCargo = itemPlanCargo.nombre;
      registro.codigoPlanCargo = itemPlanCargo.codigo;
    } else {
      registro.planCargo = null;
      registro.codigoPlanCargo = null;
    }
    const itemPerfilRiesgo = this.lisPerfilesTodos.find(x => x.idPerfilRiesgo === registro.idPerfilRiesgo);
    if (itemPerfilRiesgo) {
      registro.perfilRiesgo = itemPerfilRiesgo.nombreRiesgo;
      registro.codigoPerfilRiesgo = itemPerfilRiesgo.codigo;
    } else {
      registro.perfilRiesgo = null;
      registro.codigoPerfilRiesgo = null;
    }
  }


  finalizarGuardado(registro: any, tipo: number) {
    this.reiniciarForm();
    this.cargarPerfiles();
    this.navService.setMesage(tipo);
    this.cargando = false;
  }

  editar(registro: GarantiasIdoneasCobrosPerfilesRiesgos) {
    this.regSeleccionado = registro;
    this.reiniciarForm(false);
  }

  regresar(dirty: boolean) {
    if (dirty) {
      this.conService.confirm({
        message: this.navService.buscarMensaje('MSG_CANCELARCAMBIOS'),
        header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        key: `garantia-idonea-cobros-perfiles`,
        accept: () => {
          this.reiniciarForm();
        },
        reject: () => {
        }
      });
    } else {
      this.reiniciarForm();
    }
  }

  inhabilitar(registro: GarantiasIdoneasCobrosPerfilesRiesgos) {

    this.conService.confirm({
      message: this.navService.buscarMensaje('GARANTIASIDONEAS.MSG_CONFIRMACIONELIMINADO'),
      header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
      icon: 'fa fa-question-circle',
      key: 'garantia-idonea-cobros-perfiles',
      accept: () => {
        this.cargando = true;
        registro.indicadorHabilitado = false;
        this.garIdoneaCobroPerfilRiesgoService.verificarRango(registro).subscribe(response => {
          if (response.estado) {
            this.garIdoneaCobroPerfilRiesgoService.actualizar(registro).subscribe(rta => {
              this.actualizarTabla()
              this.reiniciarForm()
              this.cargando = false;
              this.navService.setMesage(1);
            }, error => {
              this.cargando = false;
              this.navService.setMesage(3);
            });
          } else {
            this.garIdoneaCobroPerfilRiesgoService.actualizarBulk(response.listado).subscribe(rta => {
              this.actualizarTabla()
              this.reiniciarForm()
              this.cargando = false;
              this.navService.setMesage(1);
            }, error => {
              this.cargando = false;
              this.navService.setMesage(3);
            });
          }
        }, error => {
          this.navService.setMesage(3);
        });
      },
      reject: () => {
      }
    });
  }

  get f() {
    return this.formulario.controls;
  }

  reiniciarForm(setSeleccionado: boolean = true) {
    if (setSeleccionado) {
      this.regSeleccionado = null;
    }
    this.submitted = false;
    this.cargarFormulario();
    this.formulario.markAsPristine();
  }

  formateoRango(x) {
    // return Number.parseFloat(x).toFixed(6);
    if (x) {
      console.log(Number.parseFloat(x).toFixed(6))
    }
  }

  validarValorMaximo() {
    const rangoMaximo = parseFloat(this.formulario.get('montoFinal').value);
    const rangoMinimo = parseFloat(this.formulario.get('montoInicial').value);

    this.validarMaximo = (rangoMaximo > rangoMinimo) ? true : false;

    console.log(this.validarMaximo)
  }

  async actualizarTabla() {
    this.garIdoneaCobroPerfilRiesgoService.listadoPorIdGarantiaIdonea(this.garantiaIdonea.idGarantiaIdonea).subscribe(
      async (response) => {
        this.listadoTodos = response;
        this.cargarListado();
      },
      (error) => {
        this.navService.setMesage(3);
      }
    );
  }
}
